import React from 'react';
import { styled } from '@linaria/react';

import Demo, { DemoSliderControl } from '@/components/Demo';

function HueRotateDemo() {
  return (
    <Demo
      outputWrapper={OutputWrapper}
      customGrid={{
        gridTemplateColumns: 'min(400px, 100%)',
        justifyContent: 'center',
      }}
      initialValues={{
        hueRotate: 0,
      }}
      controls={[
        <DemoSliderControl
          key="hueRotate"
          id="hueRotate"
          label="Hue Rotate"
          min={0}
          max={360}
          previewRenderer={(value) => {
            return `${value}deg`;
          }}
        />,
      ]}
    >
      {({ hueRotate }) => {
        return (
          <Image
            src="/images/color-shifting/bird.jpg"
            alt="A photo of a colorful bird"
            style={{
              filter: `hue-rotate(${hueRotate}deg)`,
            }}
          />
        );
      }}
    </Demo>
  );
}

const OutputWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Image = styled.img`
  display: block;
  width: 500px;
  max-width: 100%;
  aspect-ratio: 1920 / 1282;
  border-radius: 8px;
`;

export default HueRotateDemo;
